import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import TitleSectionOne from 'components/LandingPageTitleSection/TitleSectionOne';
import React from 'react';
import Styles from './styles.js';
const SoulroomersGallery = () => {
  return (
    <>
      <div className="container-fluid px-0 pt-4 " style={{ backgroundColor: '#161616' }}>
        <HeadingSection title="LIFE AT SOULROOMS" bgcolor="black" />
        <div className="lg:container mx-auto">
          <div className="px-xxl-4 mx-xxl-1">
            <iframe
              id="iframe-undefined6"
              className="galleryIframe"
              frameBorder={0}
              sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-presentation allow-top-navigation"
              src='javascript: window.frameElement.getAttribute("srcdoc");'
              srcDoc='<script>window.onmessage = function(event) {event.source.postMessage({iframeId: event.data, scrollHeight: document.body.getBoundingClientRect().height || document.body.scrollHeight}, event.origin);};</script><body  style=&apos;overflow: hidden; margin: 0&apos;><div class=&apos;embedsocial-album&apos; data-ref="7437cf1850b72bb1bd1f421952228427f0a7a63a"></div><script>(function(d, s, id){var js; if (d.getElementById(id)) {return;} js = d.createElement(s); js.id = id; js.src = "https://embedsocial.com/embedscript/ei.js"; d.getElementsByTagName("head")[0].appendChild(js);}(document, "script", "EmbedSocialScript"));</script></body>'
              style={{
                width: '100%',
                overflow: 'visible',
                transition: 'height 1.5s ease 0s',
              }}></iframe>
            <TitleSectionOne
              title="JOIN THE GANG, BE A SOULROOMER!"
              btnTxt="Find Your SoulRoom "
              bg="black"
              href="#JotFormIFrame-91797058303261"
            />
          </div>
        </div>
      </div>
      <Styles/>
    </>
  );
};

export default SoulroomersGallery;
